module.exports = __webpack_public_path__ + "media/student_finance/student-finance_background-9335f2e1.png";